import { InstallationExtensionsModel } from '../models/installation-extensions.model'
import { ExtensionState, ExtensionType, ExtensionTypes } from '../types'

interface ReturnType {
  inexogyState: ExtensionState | undefined
  luoxDirectMarketingState: ExtensionState | undefined
  luoxDynamicTariffState: ExtensionState | undefined
  ostromState: ExtensionState | undefined
  tibberState: ExtensionState | undefined
  ai360PowerShareState: ExtensionState | undefined
  ai360PowerFixState: ExtensionState | undefined
  hasAtLeastOneContractState: boolean
}

/**
 * Returns the contract states for all installation extensions
 */
export const getContractStates = (installationExtensionsState: InstallationExtensionsModel[]): ReturnType => {
  const inexogyState = getExtensionContractState(installationExtensionsState, ExtensionTypes.Inexogy)
  const luoxDirectMarketingState = getExtensionContractState(installationExtensionsState, ExtensionTypes.LuoxOne)
  const luoxDynamicTariffState = getExtensionContractState(installationExtensionsState, ExtensionTypes.LuoxTwo)
  const ostromState = getExtensionContractState(installationExtensionsState, ExtensionTypes.OStrom)
  const tibberState = getExtensionContractState(installationExtensionsState, ExtensionTypes.Tibber)
  const ai360PowerShareState = getExtensionContractState(installationExtensionsState, ExtensionTypes.Ai360PowerShare)
  const ai360PowerFixState = getExtensionContractState(installationExtensionsState, ExtensionTypes.Ai360PowerFix)

  // Adjust this if a new contract state is added above
  const hasAtLeastOneContractState = [
    inexogyState,
    luoxDirectMarketingState,
    luoxDynamicTariffState,
    ostromState,
    tibberState,
    ai360PowerShareState,
    ai360PowerFixState,
  ].some(Boolean)

  return {
    inexogyState,
    luoxDirectMarketingState,
    luoxDynamicTariffState,
    ostromState,
    tibberState,
    ai360PowerShareState,
    ai360PowerFixState,
    hasAtLeastOneContractState,
  }
}

/**
 * Returns the contract status for a given installation extension
 *
 * TODO: export necessary?
 */
export const getExtensionContractState = (
  installationExtensionsState: InstallationExtensionsModel[],
  extensionType: ExtensionType
): ExtensionState | undefined => {
  return installationExtensionsState.find(extension => extension.extension === extensionType)?.state
}

/**
 * Only one price tariff can be active at a time: luox, Ostrom, Tibber and the ai360 tariffs are mutually exclusive.
 */
export const getHasActiveTariff = (contractStates: ReturnType): boolean => {
  const { luoxDynamicTariffState, ostromState, tibberState, ai360PowerShareState, ai360PowerFixState } = contractStates

  return [luoxDynamicTariffState, ostromState, tibberState, ai360PowerShareState, ai360PowerFixState].includes('active')
}
